"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var react_1 = require("react");
var __1 = require("../../../");
var chroma_js_1 = __importDefault(require("chroma-js"));
var __2 = require("../../../");
var useOnClickOutside_1 = require("../../../hooks/useOnClickOutside");
var react_i18next_1 = require("react-i18next");
var utils_1 = require("../../../utils/utils");
var StyledSearch = (0, styled_components_1.default)("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n\n  .lsm-input .input-and-fieldset input {\n    &:focus {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n\n      ~ .fieldset {\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n\n    &:not(:focus) ~ .fieldset {\n      border-color: transparent;\n    }\n  }\n\n  input::placeholder {\n    color: currentColor;\n    opacity: 0.5;\n  }\n\n  .search-input-wrapper {\n    position: relative;\n  }\n\n  .search-input-button {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: opacity 0.2s ease-in-out;\n    appearance: none;\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    color: ", ";\n\n    &:hover {\n      opacity: 0.75;\n    }\n\n    svg {\n      width: 20px;\n      height: 20px;\n\n      path {\n        fill: ", ";\n      }\n    }\n  }\n\n  .search-input-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    max-height: ", ";\n    overflow-y: auto;\n    display: ", ";\n    background-color: ", ";\n    border-width: 0.5px;\n    border-style: solid;\n    border-color: ", ";\n    border-top: none;\n    box-sizing: border-box;\n    border-radius: ", "px;\n    padding: 0px 6px;\n    z-index: 1;\n    box-shadow: 0px 10px 15px #00000019;\n\n    > * {\n      font-weight: 400;\n      padding: 15px;\n      cursor: pointer;\n      transition: background-color 0.2s ease-in-out;\n\n      &:last-child {\n        border-bottom-left-radius: ", "px;\n        border-bottom-right-radius: ", "px;\n      }\n\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    ::-webkit-scrollbar {\n      width: 1px;\n    }\n    ::-webkit-scrollbar-thumb {\n      background-color: ", ";\n    }\n  }\n"], ["\n  position: relative;\n  width: 100%;\n\n  .lsm-input .input-and-fieldset input {\n    &:focus {\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n\n      ~ .fieldset {\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n      }\n    }\n\n    &:not(:focus) ~ .fieldset {\n      border-color: transparent;\n    }\n  }\n\n  input::placeholder {\n    color: currentColor;\n    opacity: 0.5;\n  }\n\n  .search-input-wrapper {\n    position: relative;\n  }\n\n  .search-input-button {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: opacity 0.2s ease-in-out;\n    appearance: none;\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    color: ", ";\n\n    &:hover {\n      opacity: 0.75;\n    }\n\n    svg {\n      width: 20px;\n      height: 20px;\n\n      path {\n        fill: ", ";\n      }\n    }\n  }\n\n  .search-input-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    height: ", ";\n    max-height: ", ";\n    overflow-y: auto;\n    display: ", ";\n    background-color: ", ";\n    border-width: 0.5px;\n    border-style: solid;\n    border-color: ", ";\n    border-top: none;\n    box-sizing: border-box;\n    border-radius: ", "px;\n    padding: 0px 6px;\n    z-index: 1;\n    box-shadow: 0px 10px 15px #00000019;\n\n    > * {\n      font-weight: 400;\n      padding: 15px;\n      cursor: pointer;\n      transition: background-color 0.2s ease-in-out;\n\n      &:last-child {\n        border-bottom-left-radius: ", "px;\n        border-bottom-right-radius: ", "px;\n      }\n\n      &:hover {\n        background-color: ", ";\n      }\n    }\n\n    ::-webkit-scrollbar {\n      width: 1px;\n    }\n    ::-webkit-scrollbar-thumb {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.gray1);
}, function (_a) {
    var loading = _a.loading;
    return !loading && "currentColor";
}, function (_a) {
    var isFocused = _a.isFocused;
    return (isFocused ? "auto" : "0");
}, function (_a) {
    var isFocused = _a.isFocused;
    return (isFocused ? "250px" : "0");
}, function (_a) {
    var isFocused = _a.isFocused;
    return (isFocused ? "block" : "none");
}, function (_a) {
    var theme = _a.theme;
    return theme.white;
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, (0, chroma_js_1.default)(theme.white).alpha(0.6).css(), (0, chroma_js_1.default)(theme.gray3).alpha(0.5).css());
}, function (_a) {
    var theme = _a.theme;
    return theme.buttonRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputRadius;
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, (0, chroma_js_1.default)(theme.gray1).brighten(0.2).css(), (0, chroma_js_1.default)(theme.gray5).darken(0.2).css());
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryColor;
});
var IconSearch = function () {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M8 2.82715C4.68629 2.82715 2 5.51344 2 8.82715C2 12.1409 4.68629 14.8271 8 14.8271C11.3137 14.8271 14 12.1409 14 8.82715C14 5.51344 11.3137 2.82715 8 2.82715ZM0 8.82715C0 4.40887 3.58172 0.827148 8 0.827148C12.4183 0.827148 16 4.40887 16 8.82715C16 10.6759 15.3729 12.3781 14.3199 13.7328L19.7071 19.12C20.0976 19.5106 20.0976 20.1437 19.7071 20.5343C19.3166 20.9248 18.6834 20.9248 18.2929 20.5343L12.9056 15.147C11.551 16.2001 9.84871 16.8271 8 16.8271C3.58172 16.8271 0 13.2454 0 8.82715Z", fill: "#4A4A4A" }) })));
};
var Search = function (props) {
    var children = props.children, placeholder = props.placeholder, icon = props.icon, loading = props.loading, onSearch = props.onSearch, onChange = props.onChange, onSubmit = props.onSubmit, filterOptions = props.filterOptions, _a = props.className, className = _a === void 0 ? "" : _a;
    var _b = React.useState(""), value = _b[0], setValue = _b[1];
    var _c = React.useState(false), isFocused = _c[0], setIsFocused = _c[1];
    var childrenList = React.Children.toArray(children);
    var ref = (0, react_1.useRef)(null);
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useOnClickOutside_1.useOnClickOutside)(ref, function () { return setIsFocused(false); });
    var toggleFocus = function () {
        setIsFocused(function (isFocused) { return !isFocused; });
    };
    var filterChildren = function (childrenList) {
        return childrenList
            .filter(function (child) {
            if (React.isValidElement(child)) {
                if (typeof filterOptions === "function") {
                    return filterOptions();
                }
                else {
                    return child.props.children
                        .toLowerCase()
                        .includes(value.toLowerCase());
                }
            }
            return false;
        })
            .map(function (child) {
            if (React.isValidElement(child)) {
                return React.cloneElement(child, {
                    // TODO fix this, but how ?
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    onClick: function (e) {
                        onChange && onChange(child.props.children);
                        toggleFocus();
                        setValue(child.props.children);
                        if (child.props.onClick) {
                            child.props.onClick(e);
                        }
                    },
                });
            }
            return child;
        });
    };
    return ((0, jsx_runtime_1.jsxs)(StyledSearch, __assign({ className: "wellms-component ".concat(className), ref: ref, isFocused: isFocused, loading: loading }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "search-input-wrapper" }, { children: [(0, jsx_runtime_1.jsx)(__1.Input, { placeholder: placeholder, onChange: function (e) {
                            var value = e.target.value;
                            setValue(value);
                            onSearch && onSearch(value);
                        }, value: value, onKeyDown: function (e) {
                            return e.key === "Enter" && onSubmit && onSubmit(value);
                        }, onFocus: function () { return toggleFocus(); } }), (0, jsx_runtime_1.jsx)("button", __assign({ type: "button", className: "search-input-button", onClick: function () {
                            onSubmit && onSubmit(value);
                        }, "aria-label": t("Search.Search") }, { children: loading ? (0, jsx_runtime_1.jsx)(__1.Spin, { color: "currentColor" }) : icon || (0, jsx_runtime_1.jsx)(IconSearch, {}) }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "search-input-options" }, { children: filterChildren(childrenList).length ? (filterChildren(childrenList)) : ((0, jsx_runtime_1.jsx)(__2.Text, __assign({ size: "12" }, { children: t("Search.NoResults") }))) }))] })));
};
exports.Search = Search;
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(exports.Search)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2;
